import { render, staticRenderFns } from "./V2ProfileGeneral.vue?vue&type=template&id=5a5f7bfa&scoped=true&"
import script from "./V2ProfileGeneral.vue?vue&type=script&lang=js&"
export * from "./V2ProfileGeneral.vue?vue&type=script&lang=js&"
import style0 from "./V2ProfileGeneral.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./V2ProfileGeneral.vue?vue&type=style&index=1&id=5a5f7bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5f7bfa",
  null
  
)

export default component.exports